import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { message } from 'antd';
import { API_BASE } from '../config';

export const BranchContext = createContext({
    branches: [],
    selectedBranch: null,
    warehouses: [],
    defaultWarehouseId: null,
    loadingBranches: false,
    loadingWarehouses: false,
    handleBranchChange: () => { },
});

export const BranchProvider = ({ children }) => {

    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(

        () => {
            const storedBranch = localStorage.getItem("selectedBranch");
            return storedBranch && storedBranch !== 'null' && storedBranch !== 'undefined' ? storedBranch : null;
        }
    );
    const [loadingBranches, setLoadingBranches] = useState(false);

    const [warehouses, setWarehouses] = useState([]);
    const [defaultWarehouseId, setDefaultWarehouseId] = useState(null);
    const [loadingWarehouses, setLoadingWarehouses] = useState(false);

    const fetchBranches = useCallback(async () => {
        const dbName = localStorage.getItem("dbName");
        if (!dbName) {
            console.log("BranchContext: dbName bulunamadı, şube isteği atlanıyor.");
            setBranches([]);
            return;
        }
        setLoadingBranches(true);
        const headers = { "Content-Type": "application/json", DbName: dbName };
        try {
            const res = await fetch(`${API_BASE}/Branch`, { headers });
            if (!res.ok) throw new Error("Şube verileri alınamadı.");
            const data = await res.json();
            setBranches(Array.isArray(data) ? data : []);

            const currentSelected = localStorage.getItem("selectedBranch");
            const branchesExist = Array.isArray(data) && data.length > 0;
            const selectionIsValid = data.some(b => b.id === currentSelected);

            if (branchesExist && (!currentSelected || !selectionIsValid)) {
                console.log("BranchContext: Geçerli şube seçimi yok veya geçersiz, ilk şube varsayılan olarak ayarlanıyor.");
                handleBranchChange(data[0].id);
            }

        } catch (error) {
            message.error(error.message);
            setBranches([]);
        } finally {
            setLoadingBranches(false);
        }
    }, []);
    const fetchDefaultWarehouse = useCallback(async (branchId) => {
        if (!branchId || branchId === 'null' || branchId === 'undefined') {
            setDefaultWarehouseId(null);
            return;
        }

        setLoadingWarehouses(true);
        setDefaultWarehouseId(null);

        const dbName = localStorage.getItem("dbName");
        if (!dbName) {
            message.error("Veritabanı bilgisi eksik, depo alınamıyor.");
            setLoadingWarehouses(false);
            return;
        }
        const headers = { "Content-Type": "application/json", DbName: dbName };

        try {
            const response = await fetch(`${API_BASE}/Warehouse?branchId=${branchId}`, { headers });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("BranchContext Depo API Hata Detayı:", errorText);
                throw new Error(`Şubeye ait depolar getirilemedi (HTTP ${response.status}).`);
            }

            const warehousesData = await response.json();
            setWarehouses(Array.isArray(warehousesData) ? warehousesData : []);

            if (warehousesData && warehousesData.length > 0) {
                const firstWarehouse = warehousesData[0];
                setDefaultWarehouseId(firstWarehouse.id);
            } else {
                message.warning(`Seçili şube (${branchId}) için kayıtlı depo bulunamadı.`);
                setDefaultWarehouseId(null);
            }
        } catch (error) {
            message.error(error.message || 'Varsayılan depo bilgisi alınırken bir hata oluştu.');
            console.error("BranchContext fetchDefaultWarehouse hatası:", error);
            setWarehouses([]);
            setDefaultWarehouseId(null);
        } finally {
            setLoadingWarehouses(false);
        }
    }, []);
    useEffect(() => {
        fetchBranches();
        window.addEventListener('loginSuccess', fetchBranches);
        return () => {
            window.removeEventListener('loginSuccess', fetchBranches);
        };
    }, [fetchBranches]);
    useEffect(() => {
        fetchDefaultWarehouse(selectedBranch);
    }, [selectedBranch, fetchDefaultWarehouse]);

    const handleBranchChange = (branchId) => {
        if (branchId) {
            setSelectedBranch(branchId);
            localStorage.setItem("selectedBranch", branchId);
        } else {
            setSelectedBranch(null);
            localStorage.removeItem("selectedBranch");
        }
    };
    const value = {
        branches,
        selectedBranch,
        warehouses,
        handleBranchChange,
        loadingBranches,
        defaultWarehouseId,
        loadingWarehouses
    };

    return (
        <BranchContext.Provider value={value}>
            {children}
        </BranchContext.Provider>
    );
};

export const useBranch = () => {
    const context = useContext(BranchContext);
    if (context === undefined) {
        throw new Error('useBranch must be used within a BranchProvider');
    }
    return context;
};